'use client';

import { useState, useEffect } from 'react';
import { trackCategoryFilter } from '@/lib/analytics';


interface Category {
  id: string;
  name: string;
  icon: string;
}

const categories: Category[] = [
  { id: 'all', name: 'All', icon: '📰' },
  { id: 'tech', name: 'Technology', icon: '💻' },
  { id: 'business', name: 'Business', icon: '💼' },
  { id: 'sports', name: 'Sports', icon: '⚽' },
  { id: 'politics', name: 'Politics', icon: '🏛️' },
  { id: 'entertainment', name: 'Entertainment', icon: '🎬' },
  { id: 'health', name: 'Health', icon: '🏥' },
  { id: 'fashion', name: 'Fashion', icon: '👗' },
  { id: 'world', name: 'World', icon: '🌍' },
  { id: 'social', name: 'Social', icon: '👥' },
  { id: 'travel', name: 'Travel', icon: '✈️' },
  { id: 'science', name: 'Science', icon: '🔬' },
];

interface CategoryFilterProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  currentCountry?: string;
}

export default function CategoryFilter({ selectedCategory, onCategoryChange, currentCountry = 'WORLD' }: CategoryFilterProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleCategoryClick = (categoryId: string) => {
    trackCategoryFilter(categoryId, currentCountry);
    onCategoryChange(categoryId);
  };

  if (!isHydrated) {
    return (
      <div className="flex gap-2 overflow-x-auto custom-scrollbar pb-2 justify-center">
        {categories.map((category) => (
          <div
            key={category.id}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-card border border-border min-w-fit"
          >
            <span className="text-sm">{category.icon}</span>
            <span className="text-xs font-medium text-foreground whitespace-nowrap">{category.name}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex gap-2 overflow-x-auto custom-scrollbar pb-2 justify-center">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => handleCategoryClick(category.id)}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border transition-all duration-200 min-w-fit ${
            selectedCategory === category.id
              ? 'bg-gradient-to-r from-blue-500 to-purple-600 border-transparent text-white shadow-md scale-105'
              : 'bg-card border-border text-foreground hover:border-primary hover:bg-primary/5 hover:scale-105'
          }`}
        >
          <span className="text-sm">{category.icon}</span>
          <span className="text-xs font-medium whitespace-nowrap">{category.name}</span>
        </button>
      ))}
    </div>
  );
}